module.exports = function(done, value){
  return {value: value, done: !!done};
};


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/~/core-js/library/modules/$.iter-step.js
// module id = ./node_modules/vue2-google-maps/node_modules/core-js/library/modules/$.iter-step.js
// module chunks = 0